/**
 * Класс содержит типовые тексты ошибок отображаемые на площадке
 */
// import { AuthService } from '../../service/auth.service';

export type ErrorMessageType = {
  pattern: string;
  required: string;
  compare: string;
  email: string;
  loginUsed: string;
  maxlength: string;
  minlength: string;
  max: string;
  min: string;
  snils: string;
  emptyFile: string;
  file: string;
};
  export const ErrorMessage: ErrorMessageType = {
  pattern: 'Введено некорректное значение',
  required: 'Данное поле является обязательным',
  compare: 'Введенные значения не совпадают',
  email: 'Некорректный адрес электронной почты',
  loginUsed: 'Данный логин уже используется в системе',
  maxlength: 'Превышена максимальная длина текста',
  minlength: 'Слишком короткое значение',
  max: 'Указано слишком большое значение',
  min: 'Указано слишком маленькое значение',
  snils: 'Введенное значение не прошло проверку на контрольное значение',
  emptyFile: 'Вы прикрепили пустой файл',
  file: (
    'Допустимые форматы прикрепляемых файлов: zip, rar, txt, rtf, doc, xls, docx,' +
    ' xlsx, odt, ods, odf, pdf, jpg, jpeg,' +
    ' gif, bmp, tif, tiff, png, psd, djvu. Максимальный допустимый размер прикрепляемого файла ' +
    // AuthService.MAX_FILE_SIZE_MB + // пока сервиса нет, но позже можно будет привязать размер файла к пользователю
    'Мб'
  ),
}
